export default __webpack_public_path__ + "static/media/thirdImageSlide.cf738e43.png";